export default __webpack_public_path__ + "static/media/veryGood.3ee6801b.gif";